export default __webpack_public_path__ + "static/media/Bg-7.8c3efab7.png";